export const WORKSAPCE_USER_ROLE = {
    ADMIN: "Administrator",
    LP_PLANNER: "LPPlanner",
    VCO_PLANNER: "VCOPlanner",
    VIEWER: "Viewer"
}
